var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { t } from "i18next";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { AppointmentList } from "../../api/url";
import { FreaturedRecheduedIcon } from "../../assets/images";
import { MuiPopup } from "../../components";
import CancelSuccessfullyPopup from "../../components/molecules/cancelSuccessfullyPopup";
import AppointmentAssignReassignPopup from "../../components/templates/AppointmentAssignReassignPopup";
import CancelDocumentModal from "../../components/templates/cancelDocumentModal";
import { ECancelDocSystemName, EMenuFeature, LOCAL_STORAGE_KEYS } from "../../constants";
import { setDocDataUpdated } from "../../redux/commonSlice";
import { resetState, setState } from "../../redux/crudSlice";
import { useAppDispatch, useAppSelector } from "../../store/hooks";
import { getLocalStorageItem } from "../../utils/storageHelper";
import { getCTAList, transactionEventLog } from "../../utils/utils";
import List from "../commonViews/list/list";
import RescheduleAppointmentModal from "./rescheduleAppointmentModal";
var listVariants = ["My Appointments", "All Appointments"];
var AppointmentLists = function () {
    var navigate = useNavigate();
    var dispatch = useAppDispatch();
    var _a = useAppSelector(function (state) { return state.crud; }), getAppointmentList = _a.getAppointmentList, isLoadinggetAppointmentList = _a.isLoadinggetAppointmentList;
    var _b = useState(false), isAssignModalOpen = _b[0], setIsAssignModalOpen = _b[1];
    var _c = useState(""), assignValue = _c[0], setAssignValue = _c[1];
    var _d = useState(false), isRescheduleModalOpen = _d[0], setIsRescheduleModalOpen = _d[1];
    var _e = useState(false), isCancelModalOpen = _e[0], setIsCancelModalOpen = _e[1];
    var _f = useState({}), clickIndexItem = _f[0], setClickIndexItem = _f[1];
    var _g = useState(''), appointmentCode = _g[0], setAppointmentCode = _g[1];
    var _h = useState(false), cancelledSuccessfulPopup = _h[0], setCancelledSuccessfulPopup = _h[1];
    var storedAllMenuFeatures = getLocalStorageItem(LOCAL_STORAGE_KEYS.ASSIGNED_MENUS);
    var profileData = getLocalStorageItem(LOCAL_STORAGE_KEYS.USER_PROFILE_DATA);
    useEffect(function () {
        dispatch(setDocDataUpdated(false));
    }, []);
    var appointmentFeatures = getCTAList(storedAllMenuFeatures, "Appointment");
    var OnClickCreateAppointment = function () {
        var _profileData$data, _profileData$data2, _profileData$data3, _profileData$data4, _profileData$data5, _profileData$data6, _profileData$data7, _profileData$data8, _profileData$data9, _profileData$data10, _profileData$data11, _profileData$data12;
        // mixpanel.track(`create_Appointment` + ` / ${profileData?.data?.GivenName}` + ` ${profileData?.data?.FamilyName}` + ` / ${profileData?.data?.IdentityId}`, {
        //   'id': profileData?.data?.IdentityId,          // Transaction ID.
        //   'name': `${profileData?.data?.GivenName}` + ` ${profileData?.data?.FamilyName}` + ` ${profileData?.data?.IdentityId}`,
        //   'code': `${profileData?.data?.Code}` + ` ${profileData?.data?.IdentityId}`,
        //   'date': new Date() + profileData?.data?.IdentityId,
        //   'path': `${window.location.href}` + ` ${profileData?.data?.IdentityId}`,
        //   'mode': 'Add',
        //   'navigateTo': 'Appoinment Create Page'
        // });
        transactionEventLog('create_Appointment', {
            'id': profileData === null || profileData === void 0 || (_profileData$data = profileData.data) === null || _profileData$data === void 0 ? void 0 : _profileData$data.IdentityId,
            // Transaction ID.
            'name': "".concat(profileData === null || profileData === void 0 || (_profileData$data2 = profileData.data) === null || _profileData$data2 === void 0 ? void 0 : _profileData$data2.GivenName) + " ".concat(profileData === null || profileData === void 0 || (_profileData$data3 = profileData.data) === null || _profileData$data3 === void 0 ? void 0 : _profileData$data3.FamilyName) + " ".concat(profileData === null || profileData === void 0 || (_profileData$data4 = profileData.data) === null || _profileData$data4 === void 0 ? void 0 : _profileData$data4.IdentityId),
            'code': "".concat(profileData === null || profileData === void 0 || (_profileData$data5 = profileData.data) === null || _profileData$data5 === void 0 ? void 0 : _profileData$data5.Code) + " ".concat(profileData === null || profileData === void 0 || (_profileData$data6 = profileData.data) === null || _profileData$data6 === void 0 ? void 0 : _profileData$data6.IdentityId),
            'date': new Date() + (profileData === null || profileData === void 0 || (_profileData$data7 = profileData.data) === null || _profileData$data7 === void 0 ? void 0 : _profileData$data7.IdentityId),
            'path': "".concat(window.location.href) + " ".concat(profileData === null || profileData === void 0 || (_profileData$data8 = profileData.data) === null || _profileData$data8 === void 0 ? void 0 : _profileData$data8.IdentityId),
            'mode': 'Add',
            'navigateTo': 'Appoinment Create Page'
        }, profileData);
        // window.gtag(
        //   'event', `create_Appointment`, {
        //   'id': profileData?.data?.IdentityId,          // Transaction ID.
        //   'name': `${profileData?.data?.GivenName}` + ` ${profileData?.data?.FamilyName}` + ` ${profileData?.data?.IdentityId}`,
        //   'code': `${profileData?.data?.Code}` + ` ${profileData?.data?.IdentityId}`,
        //   'date': new Date() + profileData?.data?.IdentityId,
        //   'path': `${window.location.href}` + ` ${profileData?.data?.IdentityId}`,
        //   'mode': 'Add',
        //   'navigateTo': 'Appoinment Create Page'
        // });
        dispatch(setState({
            key: "AppointmentCreateStartTime",
            value: {
                'id': profileData === null || profileData === void 0 || (_profileData$data9 = profileData.data) === null || _profileData$data9 === void 0 ? void 0 : _profileData$data9.IdentityId,
                // Transaction ID.
                'name': (profileData === null || profileData === void 0 || (_profileData$data10 = profileData.data) === null || _profileData$data10 === void 0 ? void 0 : _profileData$data10.GivenName) + (profileData === null || profileData === void 0 || (_profileData$data11 = profileData.data) === null || _profileData$data11 === void 0 ? void 0 : _profileData$data11.FamilyName),
                'code': profileData === null || profileData === void 0 || (_profileData$data12 = profileData.data) === null || _profileData$data12 === void 0 ? void 0 : _profileData$data12.Code,
                'date': new Date(),
                'path': window.location.href
            }
        }));
        // setLocalStorageItem(MODULE_FLOW, { isAppointment: "Create" })
        dispatch(resetState(["documentDetailsGetById", "preDocumentFetch", "filterValue", "getCustomerInfo", "getStoredJobItems", "getModuleHeaderCount", "customerDetailsTrnalsteToJob", "ModuleDetailsGetById", "savedJobItemCreateFlow", 'customerComplaintDataImageAndAudio']));
        navigate('/appointment-create');
    };
    var onClickAppointmentCard = function (item) {
        var _profileData$data13, _profileData$data14, _profileData$data15, _profileData$data16, _profileData$data17, _profileData$data18, _profileData$data19, _profileData$data20;
        // setLocalStorageItem(MODULE_FLOW, { isAppointment: "Update" })
        dispatch(resetState(["documentDetailsGetById", "preDocumentFetch", "filterValue", "getCustomerInfo", "getStoredJobItems", "getModuleHeaderCount", "customerDetailsTrnalsteToJob", "ModuleDetailsGetById", "savedJobItemCreateFlow", 'customerComplaintDataImageAndAudio']));
        // mixpanel.track(`Appointment_Card_Click` + ` / ${profileData?.data?.GivenName}` + ` ${profileData?.data?.FamilyName}` + ` / ${profileData?.data?.IdentityId}`, {
        //   'id': profileData?.data?.IdentityId,          // Transaction ID.
        //   'name': `${profileData?.data?.GivenName}` + ` ${profileData?.data?.FamilyName}` + ` ${profileData?.data?.IdentityId}`,
        //   'code': `${profileData?.data?.Code}` + ` ${profileData?.data?.IdentityId}`,
        //   'date': new Date() + profileData?.data?.IdentityId,
        //   'path': `${window.location.href}` + ` ${profileData?.data?.IdentityId}`,
        //   'mode': 'Edit',
        //   'documentId': item.id,
        //   'navigateTo': 'Appoinment Details Page'
        // });
        // window.gtag(
        //   'event', `Appointment_Card_Click`, {
        //   'id': profileData?.data?.IdentityId,          // Transaction ID.
        //   'name': `${profileData?.data?.GivenName}` + ` ${profileData?.data?.FamilyName}` + ` ${profileData?.data?.IdentityId}`,
        //   'code': `${profileData?.data?.Code}` + ` ${profileData?.data?.IdentityId}`,
        //   'date': new Date() + profileData?.data?.IdentityId,
        //   'path': `${window.location.href}` + ` ${profileData?.data?.IdentityId}`,
        //   'mode': 'Edit',
        //   'documentId': item.id,
        //   'navigateTo': 'Appoinment Details Page'
        // });
        transactionEventLog("Appointment_Card_Click", {
            'id': profileData === null || profileData === void 0 || (_profileData$data13 = profileData.data) === null || _profileData$data13 === void 0 ? void 0 : _profileData$data13.IdentityId,
            // Transaction ID.
            'name': "".concat(profileData === null || profileData === void 0 || (_profileData$data14 = profileData.data) === null || _profileData$data14 === void 0 ? void 0 : _profileData$data14.GivenName) + " ".concat(profileData === null || profileData === void 0 || (_profileData$data15 = profileData.data) === null || _profileData$data15 === void 0 ? void 0 : _profileData$data15.FamilyName) + " ".concat(profileData === null || profileData === void 0 || (_profileData$data16 = profileData.data) === null || _profileData$data16 === void 0 ? void 0 : _profileData$data16.IdentityId),
            'code': "".concat(profileData === null || profileData === void 0 || (_profileData$data17 = profileData.data) === null || _profileData$data17 === void 0 ? void 0 : _profileData$data17.Code) + " ".concat(profileData === null || profileData === void 0 || (_profileData$data18 = profileData.data) === null || _profileData$data18 === void 0 ? void 0 : _profileData$data18.IdentityId),
            'date': new Date() + (profileData === null || profileData === void 0 || (_profileData$data19 = profileData.data) === null || _profileData$data19 === void 0 ? void 0 : _profileData$data19.IdentityId),
            'path': "".concat(window.location.href) + " ".concat(profileData === null || profileData === void 0 || (_profileData$data20 = profileData.data) === null || _profileData$data20 === void 0 ? void 0 : _profileData$data20.IdentityId),
            'mode': 'Edit',
            'documentId': item.id,
            'navigateTo': 'Appoinment Details Page'
        }, profileData);
        navigate("/appointment-Detail/".concat(item.id));
    };
    var handleMenusClick = function (data) { return __awaiter(void 0, void 0, void 0, function () {
        var _profileData$data21, _profileData$data22, _profileData$data23, _profileData$data24, _profileData$data25, _profileData$data26, _profileData$data27, _profileData$data28;
        return __generator(this, function (_a) {
            dispatch(setState({
                key: "documentDetailsGetById",
                value: {}
            }));
            if ((data === null || data === void 0 ? void 0 : data.Name) === EMenuFeature.AssignServiceAdvisor) {
                setIsAssignModalOpen(true);
                setAssignValue(data === null || data === void 0 ? void 0 : data.Name);
            }
            else if ((data === null || data === void 0 ? void 0 : data.Name) === EMenuFeature.ReassignServiceAdvisor) {
                setIsAssignModalOpen(true);
                setAssignValue(data === null || data === void 0 ? void 0 : data.Name);
            }
            else if ((data === null || data === void 0 ? void 0 : data.Name) === EMenuFeature.Reschedule) {
                setIsRescheduleModalOpen(true);
            }
            else if ((data === null || data === void 0 ? void 0 : data.Name) === EMenuFeature.Cancel) {
                setIsCancelModalOpen(true);
            }
            else if ((data === null || data === void 0 ? void 0 : data.Name) === EMenuFeature.CreateVehicleInspection) {
                // mixpanel.track(`Appointment_${data?.Name}_Status_Click` + ` / ${profileData?.data?.GivenName}` + ` ${profileData?.data?.FamilyName}` + ` / ${profileData?.data?.IdentityId}`, {
                //   'id': profileData?.data?.IdentityId,
                //   'name': `${profileData?.data?.GivenName}` + ` ${profileData?.data?.FamilyName}` + ` ${profileData?.data?.IdentityId}`,
                //   'code': `${profileData?.data?.Code}` + ` ${profileData?.data?.IdentityId}`,
                //   'date': new Date() + profileData?.data?.IdentityId,
                //   'path': `${window.location.href}` + ` ${profileData?.data?.IdentityId}`,
                //   'mode': 'Edit',
                //   'documentId': clickIndexItem?.AppointmentId,
                //   'navigateTo': 'Inspection Create Page',
                //   'description': `Inspection Create against AppointmentId: ${clickIndexItem?.AppointmentId}`
                // });
                // window.gtag(
                //   'event', `Appointment_${data?.Name}_Status_Click`, {
                //   'id': profileData?.data?.IdentityId,
                //   'name': `${profileData?.data?.GivenName}` + ` ${profileData?.data?.FamilyName}` + ` ${profileData?.data?.IdentityId}`,
                //   'code': `${profileData?.data?.Code}` + ` ${profileData?.data?.IdentityId}`,
                //   'date': new Date() + profileData?.data?.IdentityId,
                //   'path': `${window.location.href}` + ` ${profileData?.data?.IdentityId}`,
                //   'mode': 'Edit',
                //   'documentId': clickIndexItem?.AppointmentId,
                //   'navigateTo': 'Inspection Create Page',
                //   'description': `Inspection Create against AppointmentId: ${clickIndexItem?.AppointmentId}`
                // });
                transactionEventLog("Appointment_".concat(data === null || data === void 0 ? void 0 : data.Name, "_Status_Click"), {
                    'id': profileData === null || profileData === void 0 || (_profileData$data21 = profileData.data) === null || _profileData$data21 === void 0 ? void 0 : _profileData$data21.IdentityId,
                    'name': "".concat(profileData === null || profileData === void 0 || (_profileData$data22 = profileData.data) === null || _profileData$data22 === void 0 ? void 0 : _profileData$data22.GivenName) + " ".concat(profileData === null || profileData === void 0 || (_profileData$data23 = profileData.data) === null || _profileData$data23 === void 0 ? void 0 : _profileData$data23.FamilyName) + " ".concat(profileData === null || profileData === void 0 || (_profileData$data24 = profileData.data) === null || _profileData$data24 === void 0 ? void 0 : _profileData$data24.IdentityId),
                    'code': "".concat(profileData === null || profileData === void 0 || (_profileData$data25 = profileData.data) === null || _profileData$data25 === void 0 ? void 0 : _profileData$data25.Code) + " ".concat(profileData === null || profileData === void 0 || (_profileData$data26 = profileData.data) === null || _profileData$data26 === void 0 ? void 0 : _profileData$data26.IdentityId),
                    'date': new Date() + (profileData === null || profileData === void 0 || (_profileData$data27 = profileData.data) === null || _profileData$data27 === void 0 ? void 0 : _profileData$data27.IdentityId),
                    'path': "".concat(window.location.href) + " ".concat(profileData === null || profileData === void 0 || (_profileData$data28 = profileData.data) === null || _profileData$data28 === void 0 ? void 0 : _profileData$data28.IdentityId),
                    'mode': 'Edit',
                    'documentId': clickIndexItem === null || clickIndexItem === void 0 ? void 0 : clickIndexItem.AppointmentId,
                    'navigateTo': 'Inspection Create Page',
                    'description': "Inspection Create against AppointmentId: ".concat(clickIndexItem === null || clickIndexItem === void 0 ? void 0 : clickIndexItem.AppointmentId)
                }, profileData);
                dispatch(resetState(["getStoredJobItems", "customerComplaintDataImageAndAudio", "customerDetailsTrnalsteToJob", "ModuleDetailsGetById", "savedJobItemCreateFlow"]));
                navigate("/create-inspection/".concat(clickIndexItem === null || clickIndexItem === void 0 ? void 0 : clickIndexItem.AppointmentId));
            }
            return [2 /*return*/];
        });
    }); };
    var onCancelAppointmentClick = function (result) { return __awaiter(void 0, void 0, void 0, function () {
        var _result$payload, _result$payload2, _result$payload3;
        return __generator(this, function (_a) {
            if ((result === null || result === void 0 || (_result$payload = result.payload) === null || _result$payload === void 0 ? void 0 : _result$payload.statusCode) == 200 || result !== null && result !== void 0 && (_result$payload2 = result.payload) !== null && _result$payload2 !== void 0 && _result$payload2.success) {
                dispatch(setState({
                    key: "menuValue",
                    value: 'cancel'
                }));
                onCancelPopupClick(false);
                navigate("/appointment");
                setAppointmentCode((_result$payload3 = result.payload) === null || _result$payload3 === void 0 || (_result$payload3 = _result$payload3.data) === null || _result$payload3 === void 0 ? void 0 : _result$payload3.Code);
                setCancelledSuccessfulPopup(true);
            }
            return [2 /*return*/];
        });
    }); };
    var onCancelPopupClick = function (value) {
        setIsCancelModalOpen(value);
    };
    return /*#__PURE__*/ React.createElement(React.Fragment, null, /*#__PURE__*/ React.createElement(List, {
        getModuleList: getAppointmentList,
        storeModuleName: "getAppointmentList",
        isCreateButton: true,
        moduleListUrl: AppointmentList,
        listVariants: listVariants,
        menusFeatures: appointmentFeatures !== null && appointmentFeatures !== void 0 ? appointmentFeatures : [],
        onClickCard: onClickAppointmentCard,
        onClickCreateModule: OnClickCreateAppointment,
        handleMenusClick: handleMenusClick,
        itemData: function (item) { return setClickIndexItem(item); },
        createButtonText: t("Create appointment"),
        moduleName: "Appointment",
        noDataTitle: t("No appointment found"),
        noDataSubTitle: t("No appointment scheduled yet, Please create new appointment."),
        loadingState: isLoadinggetAppointmentList
    }), isAssignModalOpen && /*#__PURE__*/ React.createElement(AppointmentAssignReassignPopup, {
        isOpen: isAssignModalOpen,
        onClosed: function () {
            setIsAssignModalOpen(false);
        },
        data: assignValue,
        appointmentData: clickIndexItem,
        moduleName: "Appointment"
    }), isCancelModalOpen && /*#__PURE__*/ React.createElement(CancelDocumentModal, {
        cancelPopup: isCancelModalOpen,
        data: clickIndexItem,
        title: t("Cancel appointment"),
        subTitle: t("Are you sure you want to cancel this appointment? This action cannot be undone."),
        onCancelPopup: function (value) { return onCancelPopupClick(value); },
        onCancelClick: function (result) { return onCancelAppointmentClick(result); },
        SystemName: ECancelDocSystemName.Appointment
    }), isRescheduleModalOpen && /*#__PURE__*/ React.createElement(MuiPopup, {
        variant: "h1",
        openPopup: isRescheduleModalOpen,
        closeIcon: true,
        backdropEnable: true,
        onClose: function () {
            setIsRescheduleModalOpen(false);
        },
        padding: "16px 0px 0px 16px",
        headerIcon: FreaturedRecheduedIcon,
        containerStyle: {
            padding: "16px"
        },
        showLoaderOnPopup: true
    }, /*#__PURE__*/ React.createElement(RescheduleAppointmentModal, {
        onReschedulePopup: function (value) {
            setIsRescheduleModalOpen(value);
        },
        data: clickIndexItem,
        appointmentId: clickIndexItem ? clickIndexItem === null || clickIndexItem === void 0 ? void 0 : clickIndexItem.AppointmentId : ""
    })), cancelledSuccessfulPopup && /*#__PURE__*/ React.createElement(CancelSuccessfullyPopup, {
        documentCode: appointmentCode,
        successfulPopup: cancelledSuccessfulPopup,
        onClosePopup: function (value) {
            setCancelledSuccessfulPopup(value);
            navigate("/appointment");
        },
        title: t('Successfully cancelled!'),
        subTitle: "Appointment ".concat(appointmentCode, " has been successfully cancelled")
    }));
};
export default AppointmentLists;
